import { useQuery } from '@tanstack/react-query';

// Service
import { getSpecialCollection, getSpecialCollectionsList } from './specialCollectionsService';

export const QUERY_KEY_SPECIAL_COLLECTIONS = 'specialCollections';

/**
 * @description Get the list of admin users.
 * @param {object} queryParams
 * @param {number} queryParams.pageNumber
 * @param {number} queryParams.pageSize
 * @param {QueriesOptions} [options] useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<{specialCollectionPoints: SpecialCollection[], pagination: Pagination}, Error>}
 */
export const useGetSpecialCollectionsList = (queryParams, options) => useQuery({
  queryKey: [QUERY_KEY_SPECIAL_COLLECTIONS, queryParams],
  queryFn: () => getSpecialCollectionsList(queryParams),
  ...options,
});

/**
 * @description Get an Admin User from its ID.
 * @param {string} id
 * @param {QueriesOptions} [options] useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<
 * SpecialCollection, Error>}
 */
export const useGetSpecialCollectionQuery = (id, options) => useQuery({
  queryKey: [QUERY_KEY_SPECIAL_COLLECTIONS, id],
  queryFn: () => getSpecialCollection(id),
  ...options,
});
